(() => {
  const ELIGIBLE_VARIANTS = new Set([
    50360710725932, // White W-Cat
    50360710758700  // Gray W-Cat
  ]);

  const GIFT_VARIANT = 50367505301804;
  const GIFT_TAG = '_wcat_halloween_gift';

  // 2026/10/27 00:00 至 2026/10/31 结束，太平洋时间
const START_TIME = Date.parse('2026-10-27T00:00:00-07:00');
const END_TIME = Date.parse('2026-11-01T00:00:00-07:00');

  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);

  let syncing = false;
  let syncTimer;
  let pendingSync = false;

  async function cartRequest(path, options = {}) {
    const response = await nativeFetch(`${root}${path}`, {
      credentials: 'same-origin',
      ...options,
      headers: {
        Accept: 'application/json',
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {})
      }
    });

    if (!response.ok) {
      throw new Error(`Cart request failed: ${response.status}`);
    }

    return response.json();
  }

  function scheduleSync(delay = 50) {
  if (Date.now() < START_TIME) return;

  if (syncing) {
    pendingSync = true;
    return;
  }

  clearTimeout(syncTimer);
  syncTimer = setTimeout(syncGift, delay);
}

  async function removeGiftLine(item) {
    return cartRequest('cart/change.js', {
      method: 'POST',
      body: JSON.stringify({
        id: item.key,
        quantity: 0
      })
    });
  }

  function refreshCart(cart) {
    const detail = {
      cart,
      source: 'wcat-halloween-gift'
    };

    document.dispatchEvent(
      new CustomEvent('cart:updated', { bubbles: true, detail })
    );

    document.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true, detail })
    );

    window.dispatchEvent(
      new CustomEvent('cart:updated', { detail })
    );
  }

  async function syncGift() {
    if (syncing || Date.now() < START_TIME) return;

    syncing = true;

    try {
      const now = Date.now();
      const cart = await cartRequest('cart.js');

      const hasEligibleWCat = cart.items.some(item =>
        ELIGIBLE_VARIANTS.has(Number(item.variant_id))
      );

      const automaticGiftLines = cart.items.filter(item =>
        Number(item.variant_id) === GIFT_VARIANT &&
        item.properties &&
        String(item.properties[GIFT_TAG]) === '1'
      );

      let changed = false;

      // 活动结束后，自动移除之前自动加入的赠品
      if (now >= END_TIME) {
        for (const item of automaticGiftLines) {
          await removeGiftLine(item);
          changed = true;
        }
      }

      // 有符合条件的W-Cat，但还没有自动赠品
      else if (hasEligibleWCat && automaticGiftLines.length === 0) {
        await cartRequest('cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            items: [
              {
                id: GIFT_VARIANT,
                quantity: 1,
                properties: {
                  [GIFT_TAG]: '1'
                }
              }
            ]
          })
        });

        changed = true;
      }

      // W-Cat被删除后，自动删除赠品
      else if (!hasEligibleWCat && automaticGiftLines.length > 0) {
        for (const item of automaticGiftLines) {
          await removeGiftLine(item);
          changed = true;
        }
      }

      // 自动赠品数量始终保持为1
      else if (hasEligibleWCat && automaticGiftLines.length > 0) {
        const firstGift = automaticGiftLines[0];

        if (firstGift.quantity !== 1) {
          await cartRequest('cart/change.js', {
            method: 'POST',
            body: JSON.stringify({
              id: firstGift.key,
              quantity: 1
            })
          });

          changed = true;
        }

        for (const extraGift of automaticGiftLines.slice(1)) {
          await removeGiftLine(extraGift);
          changed = true;
        }
      }

      if (changed) {
        const updatedCart = await cartRequest('cart.js');
        refreshCart(updatedCart);
      }
    } catch (error) {
      console.warn('[W-Cat Halloween Gift]', error);
    } finally {
  syncing = false;

  if (pendingSync) {
    pendingSync = false;
    scheduleSync(0);
  }
}
  }

  // 监听主题通过Ajax执行的购物车操作
  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);

    try {
      const request = args[0];
      const url =
        typeof request === 'string'
          ? request
          : request?.url || '';

      const method = String(
        args[1]?.method || request?.method || 'GET'
      ).toUpperCase();

      if (
        method !== 'GET' &&
        /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url)
      ) {
        scheduleSync();
      }
    } catch (error) {
      console.warn('[W-Cat Halloween Gift Listener]', error);
    }

    return response;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleSync(0));
  } else {
    scheduleSync(0);
  }

  window.addEventListener('pageshow', () => scheduleSync(0));
})();